import React, { useState, useEffect } from 'react'

import { Card } from 'antd'
import ListActionsPlanFilter from './ListActionsPlanFilter'
import ListActionsPlanList from './ListActionsPlanList'
import { validRule, RULES } from '../../constants/Entitlements'

const ListActionsPlan = ({ history }) => {
  const [categories, setCategories] = useState([])
  const [filters, setFilters] = useState([])

  useEffect(() => {
    const hasAccess = validRule(RULES.ACAO) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }
  }, [])

  const passData = (data, params) => {
    setCategories(data)
    setFilters(params)
  }

  return (
    <>
      <Card className="ant-card gx-card ant-card-bordered">
        <ListActionsPlanFilter passData={passData} />
        <ListActionsPlanList history={history} formatedCategories={categories} params={filters} />
      </Card>
    </>
  )
}

export default ListActionsPlan
